<section class="clienti-wrapper">
  <div class="clienti-container">
    <!-- Header: titolo + statistiche -->
    <header class="clienti-header">
      <div class="title-block">
        <div class="title-block-row">
          <span class="title-icon material-symbols-outlined" aria-hidden="true">business</span>
          <div class="title-text">
            <h1 class="page-title">Clienti</h1>
          </div>
        </div>
        <!-- Chip filtro ricerca -->
        <div class="selected-filters-container" *ngIf="searchText">
          <span class="filter-chip">
            <span class="chip-label">Ricerca: {{ searchText }}</span>
            <button
              type="button"
              class="chip-remove"
              (click)="clearSearch()"
              aria-label="Rimuovi filtro"
            >
              <i class="pi pi-times"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="header-actions">
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Nuovo Cliente"
          class="add-button p-button-rounded"
          aria-label="Aggiungi nuovo cliente"
          (click)="openCreateClienteDialog()"
          *ngIf="canModify()"
        ></button>
        <div class="stats-block">
          <div class="stat-card primary">
            <span class="stat-label">Totale Clienti</span>
            <span class="stat-value">{{ clienti.length }}</span>
          </div>
          <div class="stat-card secondary" *ngIf="searchText">
            <span class="stat-label">Risultati</span>
            <span class="stat-value stat-value-filtered">{{ filteredClienti.length }}</span>
          </div>
        </div>
      </div>
    </header>

    <!-- Sezione ricerca -->
    <section class="search-section">
      <div class="search-row-compact">
        <!-- <span class="search-label">
          <i class="pi pi-search"></i>
          <span>Cerca cliente</span>
        </span> -->
        <div class="search-field">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()"
              placeholder="Cerca per ragione sociale ..."
            />
          </span>
        </div>
        <button
          *ngIf="searchText"
          type="button"
          class="clear-search-btn"
          (click)="clearSearch()"
          pTooltip="Cancella ricerca"
          tooltipPosition="top"
        >
          <i class="pi pi-times"></i>
          <span>Cancella</span>
        </button>
      </div>
    </section>

    <!-- Sezione tabella -->
    <section class="table-section" *ngIf="clienti.length > 0; else noClienti">
      <div class="table-card">
        <div class="table-content">
          <p-table
            [value]="filteredClienti"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            [resizableColumns]="true"
            [responsiveLayout]="'scroll'"
            [loading]="loading"
            class="clienti-table"
            [sortField]="'ragioneSociale'"
            [sortOrder]="1"
          >
            <ng-template pTemplate="header">
              <tr>
                <!-- <th pResizableColumn pSortableColumn="id" style="min-width: 100px; text-align: center;">
                  ID
                </th> -->
                <th pResizableColumn pSortableColumn="ragioneSociale" style="min-width: 300px">
                  Ragione Sociale
                </th>
                <th pResizableColumn pSortableColumn="tipologiaCliente" style="min-width: 120px; text-align: center;">
                  Tipologia
                </th>
                <th pResizableColumn pSortableColumn="numeroReferenze" style="min-width: 140px; text-align: center;">
                  Numero Referenze
                </th>
                <th style="width: 120px; text-align: center;" *ngIf="canModify()">
                  Azioni
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-cliente>
              <tr class="cliente-row" [class.editing]="isEditing(cliente.id)">
               <!--  <td style="text-align: center;">
                  <span class="id-badge">{{ cliente.id }}</span>
                </td> -->
                <td>
                  <!-- Modalità visualizzazione -->
                  <span class="ragione-sociale" *ngIf="!isEditing(cliente.id)">
                    {{ cliente.ragioneSociale }}
                  </span>

                  <!-- Modalità editing -->
                  <div class="edit-container" *ngIf="isEditing(cliente.id)">
                    <input
                      type="text"
                      pInputText
                      [(ngModel)]="editingRagioneSociale"
                      class="edit-input"
                      [class.error]="isEditDuplicate()"
                      [disabled]="savingEdit"
                      (keydown.enter)="!isEditDuplicate() && saveEdit()"
                      (keydown.escape)="cancelEdit()"
                      autofocus
                    />
                    <small class="p-error" *ngIf="isEditDuplicate()">
                      Cliente già esistente
                    </small>
                  </div>
                </td>
                <td style="text-align: center;">
                  <span
                    class="tipologia-badge"
                    [ngClass]="{
                      'tipologia-pubblico': cliente.tipologiaCliente === 'PUBBLICO',
                      'tipologia-privato': cliente.tipologiaCliente === 'PRIVATO'
                    }"
                    [pTooltip]="cliente.tipologiaCliente"
                    tooltipPosition="top"
                  >
                    <span class="material-symbols-outlined" *ngIf="cliente.tipologiaCliente === 'PUBBLICO'">
                      account_balance
                    </span>
                    <span class="material-symbols-outlined" *ngIf="cliente.tipologiaCliente === 'PRIVATO'">
                      business
                    </span>
                  </span>
                </td>
                <td style="text-align: center;">
                  <span 
                    class="referenze-count" 
                    [class.clickable]="cliente.numeroReferenze > 0"
                    (click)="navigateToHomeWithCliente(cliente)"
                    [pTooltip]="cliente.numeroReferenze > 0 ? 'Clicca per vedere le referenze di questo cliente' : ''"
                    tooltipPosition="top"
                  >
                    {{ cliente.numeroReferenze || 0 }}
                  </span>
                </td>
                <td class="actions-cell" *ngIf="canModify()">
                  <!-- Azioni normali -->
                  <div class="action-buttons" *ngIf="!isEditing(cliente.id)">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-text p-button-info action-btn edit-btn"
                      pTooltip="Modifica ragione sociale"
                      tooltipPosition="top"
                      (click)="startEdit(cliente)"
                    ></button>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-text p-button-danger action-btn delete-btn"
                      [pTooltip]="cliente.numeroReferenze > 0 ? 'Non è possibile eliminare un cliente con referenze associate (' + cliente.numeroReferenze + ' referenze)' : 'Elimina cliente'"
                      tooltipPosition="top"
                      [disabled]="cliente.numeroReferenze > 0"
                      (click)="confirmDelete(cliente)"
                    ></button>
                  </div>

                  <!-- Azioni editing -->
                  <div class="edit-actions" *ngIf="isEditing(cliente.id)">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-check"
                      class="p-button-rounded p-button-success p-button-sm confirm-btn"
                      pTooltip="Salva modifiche"
                      tooltipPosition="top"
                      [disabled]="!editingRagioneSociale.trim() || isEditDuplicate() || savingEdit"
                      [loading]="savingEdit"
                      (click)="saveEdit()"
                    ></button>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-rounded p-button-secondary p-button-sm cancel-btn"
                      pTooltip="Annulla modifiche"
                      tooltipPosition="top"
                      [disabled]="savingEdit"
                      (click)="cancelEdit()"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2" class="empty-message">
                  Nessun cliente trovato
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="2" class="loading-message">
                  <i class="pi pi-spin pi-spinner"></i>
                  Caricamento in corso...
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </section>

    <ng-template #noClienti>
      <section class="empty-state">
        <div class="empty-card">
          <i class="pi pi-building empty-icon"></i>
          <h2>Nessun cliente disponibile</h2>
          <p>
            Non sono presenti clienti nel database. Verifica la connessione al backend o contatta l'amministratore.
          </p>
        </div>
      </section>
    </ng-template>
  </div>
</section>

<!-- Dialog Creazione Cliente -->
<app-create-cliente-dialog
  [(visible)]="showCreateClienteDialog"
  [clienti]="clienti"
  (clienteCreated)="onClienteCreated()"
></app-create-cliente-dialog>

<!-- Dialog Conferma Eliminazione -->
<p-confirmDialog></p-confirmDialog>
